/* FABLE LAYER — motion + cart tier ladder. Additive; safe to remove. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Config: quantity discount tiers ── */
  var TIERS_ENABLED = true;
  var TIERS_END = '2026-07-05T23:59:59-04:00'; /* hides automatically after this; set null for evergreen */
  var TIERS = [
    { qty: 1, label: '10%', pct: 10 },
    { qty: 2, label: '15%', pct: 15 },
    { qty: 4, label: '20%', pct: 20 }
  ];

  /* ── Scroll reveal ── */
  function initReveal() {
    if (REDUCED || !('IntersectionObserver' in window)) return;
    var selectors = [
      '.section-header',
      '.product-section-header',
      '.product-grid .product-card',
      '.problem-grid .problem-card',
      '.trust-item',
      '.story-grid > *',
      '.bundle-feature',
      '.email-section .container > *',
      '.faq-item'
    ];
    var els = document.querySelectorAll(selectors.join(','));
    var siblingIndex = {};
    els.forEach(function (el) {
      if (el.closest('.hero')) return;
      var parentKey = el.parentNode ? Array.prototype.indexOf.call(document.querySelectorAll('*'), el.parentNode) : 0;
      siblingIndex[parentKey] = (siblingIndex[parentKey] || 0) + 1;
      var delay = Math.min((siblingIndex[parentKey] - 1) * 0.07, 0.42);
      el.classList.add('fable-reveal');
      el.style.setProperty('--reveal-delay', delay.toFixed(2) + 's');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    document.querySelectorAll('.fable-reveal').forEach(function (el) { io.observe(el); });
  }

  /* ── Header shadow on scroll ── */
  function initHeaderShadow() {
    var update = function () {
      document.body.classList.toggle('fable-scrolled', window.scrollY > 8);
    };
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ── Cart tier ladder ── */
  function tiersActive() {
    if (!TIERS_ENABLED) return false;
    if (TIERS_END && new Date(TIERS_END) - new Date() <= 0) return false;
    return true;
  }

  function cartItemCount(body) {
    var count = 0;
    body.querySelectorAll('.cart-qty-value').forEach(function (el) {
      count += parseInt(el.textContent, 10) || 0;
    });
    return count;
  }

  function tierMessage(count) {
    if (count >= 4) return '<strong>20% off unlocked</strong> — the barn’s best deal. 🎉';
    if (count >= 2) {
      var needed = 4 - count;
      return 'You’ve got <strong>15% off</strong> — add ' + needed + ' more item' + (needed > 1 ? 's' : '') + ' to unlock <strong>20%</strong>.';
    }
    if (count === 1) return 'You’ve got <strong>10% off</strong> — add 1 more item to unlock <strong>15%</strong>.';
    return 'Add 1 item to unlock <strong>10% off</strong> — stack up to <strong>20%</strong>.';
  }

  function renderTiers(body) {
    if (!tiersActive()) return;
    if (body.querySelector('.fable-tiers')) return;
    var items = body.querySelector('.cart-drawer__items');
    if (!items) return;
    var count = cartItemCount(body);
    var segs = '';
    var labels = '';
    TIERS.forEach(function (t) {
      var hit = count >= t.qty;
      segs += '<div class="fable-tiers__seg' + (hit ? ' is-full' : '') + '"></div>';
      labels += '<span class="' + (hit ? 'is-hit' : '') + '">' + t.label + '</span>';
    });
    var el = document.createElement('div');
    el.className = 'fable-tiers';
    el.innerHTML =
      '<p class="fable-tiers__msg">' + tierMessage(count) + '</p>' +
      '<div class="fable-tiers__track">' + segs + '</div>' +
      '<div class="fable-tiers__labels">' + labels + '</div>';
    items.parentNode.insertBefore(el, items);
    if (!REDUCED) {
      requestAnimationFrame(function () {
        el.querySelectorAll('.fable-tiers__seg.is-full').forEach(function (seg, i) {
          seg.style.transitionDelay = (i * 0.12) + 's';
        });
      });
    }
  }

  function initCartTiers() {
    var body = document.querySelector('[data-cart-body]');
    if (!body) return;
    renderTiers(body);
    var mo = new MutationObserver(function () {
      renderTiers(body);
    });
    mo.observe(body, { childList: true });
  }

  function init() {
    initReveal();
    initHeaderShadow();
    initCartTiers();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
